import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@pro4-erp/core-web';
import { Box, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCard } from '@/common';
import { AuditGrade } from '../types';
import { getAuditGradeForMe } from '../api/getAuditorGradeForMe';
import AuditorAvarageGrade from '../components/AuditorAvarageGrade';
import AuditorQuestions from '../components/AuditorQuestions';

const PageLayout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: '1rem' }}>
      <Typography variant="h4">{t('Auditor grade', { defaultValue: 'Auditor grade' })}</Typography>
      {children}
    </Box>
  );
};

const Page = () => {
  const query = useQuery<AuditGrade, ApiError>({
    queryKey: ['audit-grade'],
    queryFn: getAuditGradeForMe,
    retry: false,
  });

  if (query.isError) {
    return (
      <PageLayout>
        <ErrorCard error={query.error} onRetryClick={() => query.refetch()} />
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Box sx={{ mt: '0.5rem' }}>
        {query.isLoading ? <> </> : <AuditorAvarageGrade avarageGrade={query.data?.grade} />}
      </Box>
      <Box sx={{ mt: '1.5rem' }}>
        <AuditorQuestions />
      </Box>
    </PageLayout>
  );
};

export default Page;
